var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data && !_vm.isEmptySet)?_c('b-row',[_c('b-col',[_c('highcharts',{key:_vm.hcKey,attrs:{"options":_vm.chartOptions}})],1)],1):_c('b-row',{staticClass:"mb-4"},[_c('b-col',{attrs:{"cols":"12"}},[_c('chart-not-available',{attrs:{"full-page-loading":_vm.globalLoading,"active-loading":_vm.isLoading,"if-is-mop":false}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }